/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_ExampleInputs */

const en_gc_guides_start_example = /** @type {(inputs: Gc_Guides_Start_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A small expense table. Enter the formula in B4; the expected total is 165.`)
};

const zh_gc_guides_start_example = /** @type {(inputs: Gc_Guides_Start_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小型支出表示例。在 B4 输入公式，预期合计为 165。`)
};

/**
* | output |
* | --- |
* | "A small expense table. Enter the formula in B4; the expected total is 165." |
*
* @param {Gc_Guides_Start_ExampleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_example = /** @type {((inputs?: Gc_Guides_Start_ExampleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_ExampleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_example(inputs)
	return zh_gc_guides_start_example(inputs)
});
export { gc_guides_start_example as "gc.guides.start.example" }